import React, { useState } from 'react';
import Drawer from 'react-modern-drawer';
import ContainerServices from './containerServices';
import { CommonUtilities } from '../../commonUtils';
import ProjectValidationErrorListing from './ProjectValidationErrorListing';

export default function ProjectValidation(projectDetails: any) {
    const [openFirst, setOpenFirst] = React.useState(false);
    const [ValidationSummary, setValidationSummary] = useState<any[]>([]);
    const [validationsContractsSummary, setvalidationsContractsSummary] = useState<any[]>([]);



    const colorList = [{ bgColor: '#feffe0', border: '#ffe800' }, { bgColor: '#ebf9e7', border: '#36e502' }, { bgColor: '#fbecfb', border: '#e701e3' }];

    const getField = () => {

        ContainerServices.validationsSummary()
            .then((res) => {
                console.log(res)

                console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
                setValidationSummary(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));

            });

    }

    const fetchField = (errorScope: any) => {

        ContainerServices.validationsContractsSummary(errorScope)
            .then((res) => {
                console.log(res)


                setvalidationsContractsSummary(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));

                console.log(validationsContractsSummary);
                console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));

            })

    }



    return (
        <div className='ws-2 width-auto'>
            <div onClick={() => { setOpenFirst(true); getField(); }}>
                <button className="btn-xl text-center" style={{ background: "#fb922f", color: "#FFFFFF" }}>Project validation</button>
            </div>

            <Drawer open={openFirst}
                onClose={() => setOpenFirst(false)}
                direction='right'
                className='react-drawer-left full-height-vh allowHscroll' style={{ width: "100%", height: "100%" }}>

                <div className='box noBorderRadius noBorder ws-9 box pull-right'>

                    <div className="box-header  noBorderRadius bg-blue pLarge">
                        validation
                    </div>


                    <div className="ws-12 landing">
                        <div className="ws-4 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project title:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.projectName}
                                </div>
                            </div>

                        </div>

                        <div className="ws-4 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project code:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.projectCode}
                                </div>
                            </div>
                        </div>




                        <div className="ws-4 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project Status:</label>
                                <div className="label-entries text-center text-bold  ws-12 text-m mtl mb" style={{
                                    backgroundColor: '#EF534F',
                                    color: 'black',
                                    padding: '5px',
                                    width: '100px',
                                    borderRadius: '4px'
                                }}>


                                    {projectDetails.projectDetails.statusDescription}
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="ws-12 pLarge">

                        <div className="ws-12 mtl">
                            <div className="box-header well">
                                <h2 >Project level </h2>
                            </div>

                            <div className='box-content'>
                                <div className='ws-12'>
                                    <ul className="nav nav-tabs ws-12">
                                        <li ng-class="selectedMainValidationTab === 'Validations' ? 'active' : '' " className="active">Validations</li>
                                        <li ng-class="selectedMainValidationTab === 'Scope' ? 'active' : '' ">Scope</li>
                                        <li ng-class="selectedMainValidationTab === 'Transactional' ? 'active' : ''  ">Transactional</li>
                                    </ul>





                                    {
                                        ValidationSummary.map((post, index) => {
                                            return (

                                                <div key={index} onClick={() => fetchField(post.errorScope)}>
                                                    <div className="ws-4 mtl mbl">
                                                        <div className=" pLarge">
                                                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left text-center text-bold" style={{ background: colorList[index]?.bgColor, borderColor: colorList[index]?.border }}>

                                                                <div className="ws-12 capitalize">
                                                                    {post.errorScope}
                                                                </div>
                                                                <div className="ws-12 mtl">
                                                                    Warning ( {post.errorCount} )
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>





                                            )

                                        })
                                    }

                                    {
                                        validationsContractsSummary.map((post, index) => {
                                            return (
                                                <ProjectValidationErrorListing projectDetails={projectDetails.projectDetails} post={post} />
                                            )

                                        })
                                    }

                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="box-footer">
                        <a className="icon-btn edit" > Export </a>
                        <button className="icon-btn delete pull-right" onClick={() => setOpenFirst(false)}> Close </button>

                    </div>

                </div>

            </Drawer>


        </div>
    )
}
